<template>
  <div className="c-page-sizer z-1"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PageSizer',
});
</script>
